import { render, staticRenderFns } from "./KokuForm.vue?vue&type=template&id=0af841a3&"
import script from "./KokuForm.vue?vue&type=script&lang=js&"
export * from "./KokuForm.vue?vue&type=script&lang=js&"
import style0 from "./KokuForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports